import { useChangelogApi } from '@entities/changelog'
import { useOnTimezoneChange } from '@entities/viewer'

export const useKidChangelog = (): void => {
  onMounted(() => {
    void useChangelogApi()
  })

  useOnTimezoneChange(() => {
    void useChangelogApi()
  })
}
